module.exports = __webpack_public_path__ + "static/media/fertility-outreach-phone.b16340de.png";